package one.primehealth.app

expect fun targetPlatform(): TargetPlatform

enum class TargetPlatform {
    Android,
    @Suppress("EnumEntryName") iOS,
    Web
}
